import React from "react";
import "./TipsSection.scss";
import flights from  './../../assets/images/extras/flights.png';
import best from './../../assets/images/extras/best.png';
import leaderboard from './../../assets/images/extras/leaderboard.png';
import { useNavigate } from "react-router-dom";

const TipsSection = () => {
  const navigate=useNavigate();
  return (
    <div className="tips-section">
      <div className="tips-header">
        <span>Import tips to help you</span>
        <div className="divider"></div>
      </div>

      <div className="tips-container">
        <h3 className="tips-title">3 steps to become a top drone pilot on Aerial Borne</h3>
        <p className="tips-description">
          The key to your success on Aerial Borne is the brand you build for yourself through your Aerial Borne reputation.
          We gathered some tips and resources to help you become a leading seller on Fiverr.
        </p>

        <div className="tips-grid">
          <div className="tip-card">
            <img src={flights} alt="Drone Icon" className="tip-icon" />
            <h4 className="tip-title">Show your flights</h4>
            <p className="tip-text">
              Key is to add the best shoots you've done flying your drone, if it's a specialized mission like inspection
              survey etc, that will work best.
            </p> 
            <button className="tip-button" onClick={()=>navigate('add-your-services')}>Add your services</button>
          </div>

          <div className="tip-card">
            <img src={best} alt="Learning Icon" className="tip-icon" />
            <h4 className="tip-title">Learn from the best</h4>
            <p className="tip-text">
              We're building a library for courses using experts in the industry. Stay Updated!
            </p>
            <button className="tip-button disabled">Launching Soon!</button>
          </div>

          <div className="tip-card">
            <img src={leaderboard} alt="Leaderboard Icon" className="tip-icon" />
            <h4 className="tip-title">Join the leaderboard</h4>
            <p className="tip-text">
              At Aerial Borne, we send gifts and offers to the high-performing drone pilots in the industry.
              Keep flying!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSection;
